export default "__VITE_ASSET__EnckiuTp__"